import { addAlert } from '../../alerts';
import { initializePhotoPreview } from './initialize-photo-preview';

export function initializeComponentCard() {
    const tabButtons = document.querySelectorAll(
        '.card-details-tabs-nav .tab-btn',
    );
    const tabPanes = document.querySelectorAll(
        '.card-details-tabs-content .tab-pane',
    );
    const tabsContentContainer = document.querySelector(
        '.card-details-tabs-content',
    );

    let activeTabId = sessionStorage.getItem('activeComponentTab');

    if (!activeTabId) {
        activeTabId =
            tabButtons.length > 0 ? tabButtons[0].dataset.tab : 'information';
    }

    const savedButton = document.querySelector(
        `.tab-btn[data-tab="${activeTabId}"]`,
    );
    const savedPane = document.getElementById(`tab-${activeTabId}`);

    if (savedButton && savedPane) {
        savedButton.classList.add('active');
        savedPane.classList.add('active');
    }

    if (tabsContentContainer) {
        setTimeout(() => {
            tabsContentContainer.classList.add('initialized');
        }, 10);
    }

    tabButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const tabId = button.dataset.tab;

            tabButtons.forEach((btn) => btn.classList.remove('active'));
            tabPanes.forEach((pane) => pane.classList.remove('active'));

            button.classList.add('active');
            const activePane = document.getElementById(`tab-${tabId}`);
            if (activePane) {
                activePane.classList.add('active');
                sessionStorage.setItem('activeComponentTab', tabId);
            }
        });
    });

    const measurementListRows = document.querySelectorAll(
        '.results-table tbody tr',
    );
    const measurementDetailGroups = document.querySelectorAll(
        '.details-table tbody.measurement-group',
    );
    const graphWrappers = document.querySelectorAll(
        '.graphs-container .graph-item-wrapper',
    );
    const detailsHeader = document.querySelector('.test-results-section h2');
    const initialHeaderText = 'WYNIKI SPRAWDZENIA';
    const graphsSection = document.querySelector('.results-graphs-section');
    const graphsContainer = document.querySelector('.graphs-container');

    function updateGraphsSectionVisibility() {
        if (!graphsSection) return;
        const isAnyGraphVisible = Array.from(graphWrappers).some(
            (graph) => graph.style.display === 'block',
        );
        graphsSection.style.display = isAnyGraphVisible ? 'block' : 'none';
    }

    if (graphWrappers) {
        graphWrappers.forEach((graph) => (graph.style.display = 'block'));
    }
    if (measurementListRows) {
        measurementListRows.forEach((row) => {
            row.addEventListener('click', function () {
                const targetType = this.dataset.targetType;
                const isActive = this.classList.contains('active');

                measurementListRows.forEach((r) =>
                    r.classList.remove('active'),
                );

                if (isActive) {
                    measurementDetailGroups.forEach(
                        (group) => (group.style.display = 'table-row-group'),
                    );
                    graphWrappers.forEach(
                        (graph) => (graph.style.display = 'block'),
                    );
                    if (detailsHeader)
                        detailsHeader.innerHTML = initialHeaderText;

                    if (graphsContainer) {
                        graphsContainer.style.gridTemplateColumns =
                            'repeat(2, 1fr)';
                    }
                } else {
                    this.classList.add('active');

                    measurementDetailGroups.forEach(
                        (group) => (group.style.display = 'none'),
                    );
                    graphWrappers.forEach(
                        (graph) => (graph.style.display = 'none'),
                    );

                    const targetGroup = document.querySelector(
                        `.details-table tbody[data-measurement-type="${targetType}"]`,
                    );
                    if (targetGroup) {
                        targetGroup.style.display = 'table-row-group';
                    }

                    const targetGraphs = document.querySelectorAll(
                        `.graphs-container .graph-item-wrapper[data-measurement-type="${targetType}"]`,
                    );
                    targetGraphs.forEach(
                        (graph) => (graph.style.display = 'block'),
                    );

                    if (graphsContainer) {
                        if (targetGraphs.length <= 1) {
                            graphsContainer.style.gridTemplateColumns =
                                'repeat(1, 1fr)';
                        } else {
                            graphsContainer.style.gridTemplateColumns =
                                'repeat(2, 1fr)';
                        }
                    }

                    if (detailsHeader) {
                        const testName = this.children[1].textContent.trim();
                        const testDate = this.children[2].textContent.trim();
                        detailsHeader.innerHTML = `${initialHeaderText} &nbsp;&nbsp; - &nbsp;&nbsp; <span class="details-name">${testName}</span> &nbsp;&nbsp;&nbsp;&nbsp;  <span class="details-date">${testDate}</span>`;
                    }
                }
                updateGraphsSectionVisibility();
            });
        });
    }

    updateGraphsSectionVisibility();

    const generateCertButton = document.getElementById('generate-cert-btn');

    if (generateCertButton) {
        generateCertButton.addEventListener('click', function () {
            const enovaId = this.dataset.enovaId;
            const apiUrl = `/api/certificate/${enovaId}/generate-pdf/`;

            this.disabled = true;
            this.classList.add('is-loading');

            fetch(apiUrl)
                .then((response) => {
                    if (!response.ok) {
                        return response.json().then((err) => {
                            throw new Error(
                                err.message || 'Wystąpił nieznany błąd.',
                            );
                        });
                    }
                    return response.json();
                })
                .then((data) => {
                    addAlert(
                        'success',
                        gettext(
                            'Certyfikat został wygenerowany. Możesz go teraz pobrać.',
                        ),
                    );

                    const downloadContainer = document.getElementById(
                        'download-cert-container',
                    );
                    if (downloadContainer && data.url) {
                        const newLink = document.createElement('a');
                        newLink.href = data.url;
                        newLink.className = 'cancel-button';
                        newLink.target = '_blank';
                        newLink.innerText = gettext('POBIERZ CERTYFIKAT');
                        downloadContainer.innerHTML = '';
                        downloadContainer.appendChild(newLink);
                    }
                })
                .catch((error) => {
                    console.error('Błąd generowania certyfikatu:', error);
                    addAlert('error', error.message);
                })
                .finally(() => {
                    this.disabled = false;
                    this.classList.remove('is-loading');
                });
        });
    }

    initializePhotoPreview(document);
}
